import { useMutation } from '@tanstack/react-query'
import { createFastCutProductShort, createShortVideo } from '../../service/list'

function useCreateFastCutProductShort() {
  return useMutation({
    mutationKey: ['create-fast-cut-product-short'],
    mutationFn: createFastCutProductShort,
  })
}

export default useCreateFastCutProductShort
